<script lang="ts">
  import { exhaustMap, fromEvent } from 'rxjs'
  import { onMount, getContext } from 'svelte'
  import CtaButton from '../Generic/CtaButton.svelte'
  export let action: () => Promise<void>
  export let message: string
  let yesButton: HTMLButtonElement
  let noButton: HTMLButtonElement

  const { close }: { close: () => void } = getContext<{ close: () => void }>('simple-modal')
  onMount(() => {
    const yesSub = fromEvent(yesButton, 'click')
      .pipe(exhaustMap(_ => action()))
      .subscribe(_ => close())
    const noSub = fromEvent(noButton, 'click').subscribe(_ => close())
    return () => {
      yesSub.unsubscribe()
      noSub.unsubscribe()
    }
  })
</script>

<div id="card-content">
  <h2>{message}</h2>
  <div class="buttons-container">
    <CtaButton bind:inner={noButton} kind="negative">No</CtaButton>
    <CtaButton bind:inner={yesButton}>Yes</CtaButton>
  </div>
</div>

<style>
  #card-content {
    margin: 2em 1.5em;
  }
  .buttons-container {
    display: flex;
    justify-content: space-around;
  }
</style>
